import { Component, Input, inject } from '@angular/core';
import { Customer, Project } from 'TimelogDataTypes';

import { FormsModule } from '@angular/forms';
import {
  dialogData as customerDialogData,
  genericDialogComponent,
} from '../genericDialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ProjectService } from 'TimelogServices/project-service';
import { UserService } from 'BaseServices/user-service';
import { CustomerService } from 'TimelogServices/customer-service';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';

@Component({
    selector: 'app-customer-dialog',
    imports: [
    FormsModule,
    MatButtonModule,
    dialogInputTitleComponent,
    SaveButtonComponent,
    DeleteButtonComponent
],
    templateUrl: './customer-dialog.component.html',
    styleUrls: [
        '../../../../../../src/app/general-styles/dialogs.css',
        './customer-dialog.component.css',
    ]
})
export class CustomerDialogComponent extends genericDialogComponent {
  readonly data = inject<customerDialogData<Customer[]>>(MAT_DIALOG_DATA);
  @Input() customerData!: Customer;
  projects: Project[] = [];
  dialogInputTitleComponent = dialogInputTitleComponent;
  currentUser = this.userService.currentUser;
  constructor(
    public override dialogRef: MatDialogRef<CustomerDialogComponent>,
    private customerService: CustomerService,
    private projectService: ProjectService,
    public userService: UserService
  ) {
    super(dialogRef);

    this.customerData = this.data.data[0];
  }

  ngOnInit(): void {
    this.projectService.getProjects().subscribe((result) => {
      this.projects = result;
    });
  }

  /**
   * Updates customer data.
   */
  saveChanges() {
    this.customerService
      .updateCustomer(this.customerData)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }

  /**
   * Deletes a customer, if the customer don't have any projects.
   * @returns
   */
  deleteCustomer() {
    if (this.projects.some((p) => p.customerId == this.customerData.id)) {
      alert('Kunden har projekter og kan derfor ikke slettes');
      return;
    }

    if (
      !confirm(
        "Er du sikker på at du vil slette kunden '" +
          this.customerData.name +
          "'?"
      )
    ) {
      return;
    }
    this.customerService
      .deleteCustomer(this.customerData.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
